<div *ngIf="loading" class="overlay">
    <div class="spinner"></div>
</div>

<div *ngIf="errorLoading" class="error-message">
    <h6 class="server-msg"> Oh no! Couldn't Fetch Data.. <br> We'll be right back. </h6>
    <img src="/assets/car-mileage-compressed.gif" loading="lazy" height="100px" >
</div>

<blockquote>
    <h5 class="headings">TYPE OF ORGANIZATION</h5>
</blockquote>
<form>
    <div class="card">
        <div class="col">
            <div *ngIf="orgType === ''"> 
                <select style="display: block;" id="size" name="size" required [(ngModel)]="orgType">
                <option value="" disabled selected>Select Organization Type</option>
                <option *ngFor="let option of orgOptions" [value]="option.label" >{{ option.label }}</option>
                </select>
            </div>
        </div>
        <div *ngIf="orgType != ''"> 
            <h6 style="display: inline-block;"><b>Selected:</b> {{ orgType }}</h6>
            <button *ngIf="!isViewOnly" class="remove" style="display: inline-block;" (click)="removeOrgType()">Remove</button>
        </div>
    
        <div *ngIf="orgType === 'Other'">
            <h6>Provide details: </h6>
            <input name="other-org" style="width: 200px" class="white-input" [(ngModel)]="uniqueOrgType">
            <!-- <button (click)="saveOrg()">Add</button> -->
        </div>
    </div>
</form>
<br>
<blockquote>
    <h5 class="headings">TYPE OF BUSINESS</h5>
</blockquote>
<form>
    <div class="card">
        <div *ngIf="!isViewOnly">
            <h6>Select all that apply:</h6>
            <p class="industry-order-hint">
              Select industries in order of relevance, starting with your primary serving industry first, followed by any secondary industries.
            </p>
            <select style="display: block; height: 200px;" id="opts" name="opts" 
                required 
                multiple
                (change)="updateSelectedOptions($event)">
                    <option *ngFor="let option of businessOptions" [ngValue]="option.label">{{ option.label }}</option>
            </select>
        </div>
          
        <div *ngIf="busTypes.length > 0">
            <h6 style="display: inline-block;"><b>Selected:</b></h6>
            <ul style="display: inline-block;" class="type-list">
                <li class="type-item" *ngFor="let type of busTypes; let i = index">
                <button *ngIf="!isViewOnly" class="remove-btn" (click)="removeType(i)"><i class="material-icons tiny icon-inline">clear</i></button>
                <span>{{ type }}</span>
                </li>
            </ul>
        </div>
          
    
        <div *ngIf="showOtherInput">
            <h6>Provide details:</h6>
            <input name="other-bus" class="white-input" [(ngModel)]="uniqueBusType">
        </div>
    </div>
</form>